/**
 * Cuándo debe Financiero seguir consultando al servidor por su cuenta.
 *
 * "Pagar" abre la factura de Stripe en otra pestaña: el panel no se entera de que se ha pagado, y el
 * servidor tarda unos segundos en recibir el aviso de Stripe (webhook). Mientras haya algo sin resolver se
 * consulta cada pocos segundos; cuando todo está al día se deja de consultar.
 */

/** Cada cuánto se consulta mientras hay algo pendiente. */
export const BILLING_POLL_MS = 10_000;

const UNSETTLED_SUBSCRIPTION = new Set(["PENDING_PAYMENT", "BLOCKED"]);
const PENDING_INVOICE = new Set(["ISSUED", "OVERDUE"]);

/** La suscripción espera un pago que la devolvería a la normalidad. */
export function isSubscriptionUnsettled(subscription: { status: string } | null | undefined): boolean {
  return subscription != null && UNSETTLED_SUBSCRIPTION.has(subscription.status);
}

/** Alguna factura sigue pendiente de pago. */
export function hasPendingInvoice(invoices: ReadonlyArray<{ status: string }> | null | undefined): boolean {
  return invoices != null && invoices.some((invoice) => PENDING_INVOICE.has(invoice.status));
}

/** Intervalo de consulta de la suscripción: `false` = no consultar. */
export function subscriptionPollInterval(subscription: { status: string } | null | undefined): number | false {
  return isSubscriptionUnsettled(subscription) ? BILLING_POLL_MS : false;
}

/** Intervalo de consulta de un listado de suscripciones (super-admin): `false` = no consultar. */
export function subscriptionsPollInterval(
  subscriptions: ReadonlyArray<{ status: string }> | null | undefined,
): number | false {
  return subscriptions != null && subscriptions.some((s) => isSubscriptionUnsettled(s)) ? BILLING_POLL_MS : false;
}

/** Intervalo de consulta de las facturas: `false` = no consultar. */
export function invoicesPollInterval(invoices: ReadonlyArray<{ status: string }> | null | undefined): number | false {
  return hasPendingInvoice(invoices) ? BILLING_POLL_MS : false;
}
